import { render } from "./Final.vue?vue&type=template&id=0db1861d"
import script from "./Final.vue?vue&type=script&lang=ts"
export * from "./Final.vue?vue&type=script&lang=ts"

import "./Final.vue?vue&type=style&index=0&id=0db1861d&lang=scss"
script.render = render

export default script